/* eslint-disable react/no-unescaped-entities */
import { TermsAndConditions } from '@/app/features/products/common/components/TermsAndConditions';
import { AiOutlineDownload } from 'react-icons/ai/index.js';
import { useState } from 'react';
import { ProgramDataType } from '@ssar-app/domain';
import { Modal } from '@ssar-app/uikit';
import { Button, Center, Checkbox, HStack, Icon } from '@chakra-ui/react';

interface ProgramSummaryFooterProps {
  model: ProgramDataType;
  showAccept?: boolean;
  onCancel?: () => void;
  onAccept?: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDownload?: (arg0: any) => void;
  onOk?: () => void;
}

const showTermsAndConditions = (subCode: string): void => {
  const modal = Modal.confirm({
    icon: false,
    showFooterBtns: false,
    contentProps: { maxW: '80%' },
    header: 'Terms & Conditions',
    headerProps: { color: 'black', maxHeight: '100vh' },
    bodyProps: { pt: 0, pb: 6 },
    content: <></>,
  });
  const closeModal = modal.destroy;
  modal.update({
    content: (
      <TermsAndConditions
        type='ProgramSubmit'
        onAccept={(..._args) => {
          closeModal();
        }}
        onCancel={() => {
          closeModal();
        }}
        subCode={subCode}
      />
    ),
  });
};
export const ProgramSummaryFooter = (props: ProgramSummaryFooterProps) => {
  const [enableAccept, setEnableAccept] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  return (
    <div>
      {props.showAccept && props.onAccept && (
        <Center>
          <Checkbox
            onChange={(e) => {
              setEnableAccept(e.target.checked);
            }}
            checked={enableAccept}
          >
            I certify that I have an existing account relationship with this
            individual(s) and will use the consumer report information strictly
            for the FCRA permissible purpose of "account review" to assist in my
            decision to retain or modify the current account terms. Please read
            carefully, it is imperative that all Designates and End Users fully
            understand and adhere to our comprehensive{' '}
            <Button
              variant='link'
              colorScheme='blue'
              onClick={() => showTermsAndConditions(props.model?.subCode || '')}
              boxShadow={'none'}
              p={0}
            >
              Terms & Conditions
            </Button>
          </Checkbox>
        </Center>
      )}

      <HStack justify='end'>
        {props.onDownload && (
          <Button
            colorScheme='blue'
            leftIcon={<Icon as={AiOutlineDownload} />}
            isLoading={downloadLoading}
            onClick={() => {
              setDownloadLoading(true);
              props.onDownload && props.onDownload(setDownloadLoading);
            }}
            h={8}
            sx={{
              boxShadow: 'lg',
            }}
          >
            Download as PDF
          </Button>
        )}
        {props.onCancel && (
          <Button
            onClick={() => {
              props.onCancel && props.onCancel();
            }}
            h={8}
            variant={'outline'}
            colorScheme='gray'
            sx={{
              boxShadow: 'lg',
              _hover: {
                bg: 'white',
                color: 'blue.800',
                borderColor: 'blue.800',
              },
            }}
          >
            Cancel
          </Button>
        )}
        {props.showAccept && props.onAccept && (
          <Button
            colorScheme='blue'
            onClick={() => {
              props.onAccept && props.onAccept();
            }}
            disabled={!enableAccept}
            h={8}
            sx={{
              boxShadow: 'lg',
            }}
          >
            Accept
          </Button>
        )}
        {props.onOk && (
          <Button
            colorScheme='blue'
            onClick={() => {
              props.onOk && props.onOk();
            }}
            sx={{
              boxShadow: 'lg',
            }}
          >
            OK
          </Button>
        )}
      </HStack>
    </div>
  );
};
